import React from "react";
import "./Directors.css";
import DirectorDinesh from "./IMGS/Full.png";
import DirectorKhushbu from "./IMGS/Director1.png";
import DirectorNikunj from "./IMGS/Director2.png";
import { Icon } from "@iconify/react";
import linkedinIcon from "@iconify/icons-devicon/linkedin";

const directors = [
  {
    name: "Dinesh Rajput",
    image: DirectorDinesh,
    linkedin: "https://www.linkedin.com/in/dineshsinh-rajput-475383142/",
  },
  {
    name: "Khushbu Patel",
    image: DirectorKhushbu,
    linkedin: "https://www.linkedin.com/in/khushbu-patel-395116120/",
  },
  {
    name: "Nikunj Patel",
    image: DirectorNikunj,
    linkedin: "https://www.linkedin.com/in/nikunj-patel-52770416a",
  },
];

function Directors() {
  return (
    <section aria-labelledby="quarec-directors-heading">
      <h2 id="quarec-directors-heading" className="RFCeEFC">Our Directors</h2>
      <div className="DirectoreMain">
        <div className="container">
          <div className="grid">
            {directors.map((director) => (
              <article className="article" key={director.name}>
                <figure className="article__figure">
                  <img
                    className="article__cover"
                    src={director.image}
                    alt={director.name}
                    loading="lazy"
                    decoding="async"
                  />
                  <figcaption className="article__caption">
                    <div className="articaleborder">
                      <div className="subborder">
                        <h3 className="article__title">{director.name}</h3>
                        <p className="article__info">Director</p>
                        <a
                          className="article__Icon"
                          href={director.linkedin}
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label={`View ${director.name} on LinkedIn`}
                        >
                          <Icon icon={linkedinIcon} aria-hidden="true" />
                        </a>
                      </div>
                    </div>
                  </figcaption>
                </figure>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Directors;
